import { FaSearch, FaArrowRight } from "react-icons/fa";

export function ProdDescBadgeSold({ children, className = "", date = "", ...props }) {
    const badgeStyles = {
        backgroundColor: "#373434",
    };
    const badgeClasses =
        "w-[100%] h-[44px] rounded-[8px] bg-[#373434] text-[20px] leading-[24.2px] flex items-center text-neutral-50";

    return (
        <div className={`${badgeClasses} ${className}`} style={badgeStyles} {...props}>
            <div className="flex items-center justify-between w-full">
                {children}
            </div>
        </div>
    );
}
